import React, { useCallback } from 'react';
import { useRequestPayment } from '@features/payments/hooks/useRequestPayment';
import { Payment as PaymentIcon } from '@mui/icons-material';
import { useEventTracking } from '@services/statsig';

import { ToolbarButton } from '../components/ToolbarButton';
import { useToolbarAction } from '../store/hooks';
import { type ToolbarActionProps } from '../types';

export const RequestPaymentToolbarAction: React.FC<ToolbarActionProps> = ({ context, compact }) => {
  const { badgeCount } = useToolbarAction('request-payment');
  const { toolbar } = useEventTracking();

  // Use the headless payment request hook
  const { triggerPaymentRequest } = useRequestPayment({
    patientId: context?.patientId,
    encounterId: context?.encounterId,
    source: 'toolbar',
  });

  const handleClick = useCallback(() => {
    // Track toolbar action click
    toolbar.actionClicked({
      action_type: 'request_payment',
      has_patient: !!context?.patientId,
    });
    // Trigger the payment request flow
    triggerPaymentRequest();
  }, [toolbar, context?.patientId, triggerPaymentRequest]);

  // Tooltip changes based on whether a patient is selected
  const tooltipTitle = !context?.patientId
    ? 'Request payment (select patient in modal)'
    : 'Request payment from patient';

  return (
    <ToolbarButton
      icon={PaymentIcon}
      label="Payment"
      tooltip={tooltipTitle}
      onClick={handleClick}
      compact={compact}
      badgeCount={badgeCount}
      dataAttribute="toolbar-request-payment"
    />
  );
};
